// Analytics and Performance Monitoring
import { environment } from '../environment';

export const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Google Analytics tracking
export const initializeAnalytics = () => {
  if (environment.REACT_APP_ENABLE_ANALYTICS && environment.REACT_APP_GOOGLE_ANALYTICS_ID) {
    // Load Google Analytics script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.REACT_APP_GOOGLE_ANALYTICS_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    (window as any).gtag = function() {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(arguments);
    };
    
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', environment.REACT_APP_GOOGLE_ANALYTICS_ID, {
      send_page_view: false,
      debug_mode: import.meta.env.DEV
    });
  }
};

export const trackPageView = (path: string) => {
  if (environment.REACT_APP_ENABLE_ANALYTICS && (window as any).gtag) {
    (window as any).gtag('event', 'page_view', {
      page_path: path,
      page_title: document.title
    });
  }
};

export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (environment.REACT_APP_ENABLE_ANALYTICS && (window as any).gtag) {
    (window as any).gtag('event', eventName, parameters);
  }
};

// Error reporting
export const reportError = (error: Error, context?: Record<string, any>) => {
  console.error('Application error:', error, context);
  
  if (environment.REACT_APP_ENABLE_ERROR_REPORTING) {
    // Integration with error reporting service (Sentry, etc.)
    // This would be implemented based on the chosen service
    trackEvent('error', {
      error_name: error.name,
      error_message: error.message,
      error_stack: error.stack,
      ...context
    });
  }
};

// Performance monitoring
export const measurePerformance = (name: string, fn: () => void | Promise<void>) => {
  const start = performance.now();
  
  const result = fn();
  
  if (result instanceof Promise) {
    return result.finally(() => {
      const duration = performance.now() - start;
      console.log(`${name} took ${duration.toFixed(2)}ms`);
      trackEvent('performance', { name, duration });
    });
  } else {
    const duration = performance.now() - start;
    console.log(`${name} took ${duration.toFixed(2)}ms`);
    trackEvent('performance', { name, duration });
    return result;
  }
};
